import { StripeElementStyle } from '@stripe/stripe-js/types';
import styled from 'styled-components';

import { colors, fonts } from 'theme/theme';
import { getRgbaString } from 'utils/style';

export const stripeElementStyles: StripeElementStyle = {
  base: {
    fontSize: '18px',
    fontFamily: fonts.sans,
  },
  invalid: {
    color: `rgba(${getRgbaString(colors.alertRed, 1.0)})`,
  },
};

export const StripeElementContainer = styled.div`
  .StripeElement {
    height: 45px;
    border: solid 1px var(--input-highlight-color, ${colors.elementGrey});
    border-radius: 8px;
    padding: 11px 18px;
    color: ${colors.darkContentGrey};

    &--complete {
      --input-highlight-color: ${colors.brandGreen};
    }

    &--invalid {
      --input-highlight-color: ${colors.alertRed};
    }

    &--complete,
    &--invalid {
      box-shadow: 0 0 0 1px var(--input-highlight-color);
    }

    input::placeholder {
      color: ${colors.lightContentGrey};
    }

    &--focus {
      border-color: ${colors.brandBlue};
      box-shadow: 0 0 0 1px ${colors.brandBlue};
      --input-affix-color: ${colors.brandBlue};
    }
  }
`;
